import {createSelector} from 'reselect';
import {getShouldShowReturnToBasketCTAExperiment} from './ExperimentSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, getShouldShowReturnToBasketCTAExperiment],
  (settings, shouldShowReturnToBasketCTAExperiment) => (
    !!settings.show_return_to_basket_cta || shouldShowReturnToBasketCTAExperiment
  ),
);
